import type { CustomizableCookie } from './types'

// These values are set in user's cookie storage and used by other stacks.
// Do not update them.
export const COOKIES: Record<CustomizableCookie, string> = {
  advertising: 'BM_Advertising',
  analytics: 'BM_Analytics',
  userExperience: 'BM_User_Experience',
}

export const GDPR_COOKIE_DURATION_IN_MONTHS = 6

export const ESSENTIAL_ITEMS_REGEX = /^(didomi_token_|cf_|csrftoken_)/i
export const ESSENTIAL_PURPOSE_ID = 'forthebr-qmYfF3Ry'
export const ESSENTIAL_ITEMS_NAMES = [
  'ab.optOut',
  '_cfuvid',
  '__cf_bm',
  'didomi_token',
  'didomi_dcs',
  'euconsent-v2',
  'sessionid',
  'session_id',
  'visitor_id',
]
